import Swiper from 'swiper';
import Vue from 'vue';
import Card from '../card/card';
import PopupCards from '../popup/cards/popup-cards';
import AnimationFade from '../../core/animation/fade/animation-fade';

export default function () {
  const stock = document.querySelector('.stock');

  if (stock) {
    new Vue({
      el: stock,
      delimiters: ['${', '}}'],
      components: {
        Card,
        PopupCards,
        AnimationFade,
      },
      data: {
        manager: window.manager,
        popupIsOpen: false,
      },
      methods: {
        OpenPopup(index) {
          if (this.$refs.StockCardsPopup) {
            this.popupIsOpen = true;
            this.$nextTick(() => {
              const popup = this.$el.querySelector('.popup-cards');
              window.bodyLock.disableBodyScroll(popup);
              this.$refs.StockCardsPopup.slideTo(index);
            });
          }
        },
      },
      mounted() {
        const sliderBtns = [].slice.call(this.$el.querySelectorAll('.sliderButtons__btn'));
        const sliderWrp = this.$el.querySelector('.stock__slider');

        if (sliderWrp) {
          const slides = [].slice.call(this.$el.querySelectorAll('.stock__slide'));

          if (slides && slides.length > 1) {
            new Swiper(sliderWrp, {
              slidesPerView: 3,
              spaceBetween: 20,
              resistance: true,
              resistanceRatio: 0,
              navigation: {
                prevEl: sliderBtns[0],
                nextEl: sliderBtns[1],
                disabledClass: 'sliderButtons__btn--disabled',
              },
              breakpoints: {
                1023: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                767: {
                  slidesPerView: 1,
                  spaceBetween: 8,
                },
              },
            });
          }
        }
      },
    });
  }
}



// WEBPACK FOOTER //
// ./new-blocks/stock/stock.js